import { createApp } from 'vue';

import { read_app_config } from './_partials/_app.js';
import App from './ideas-app/app.vue';
import { create_store } from './jobs-app/_store.js';

(function () {
	const app_el = document.getElementById(`js-ideas-app`);
	if (!app_el) {
		return;
	}

	const config = read_app_config(app_el);

	create_store(config);

	createApp(App).mount(app_el);
})();
